import React, { useState, useEffect } from "react";
import {
  MdOutlineCalendarToday,
} from "react-icons/md";
import { TbArrowsMaximize } from "react-icons/tb";
import { Modal, Tooltip } from 'antd';
import Card from "components/card";
import {
  lineChartDataTotalSpent,
  lineChartOptionsTotalSpent,

} from "variables/charts_new";
import LineChart from "components/charts/LineChart";
import { useFetch } from "hooks/useFetch";
import { urls } from "helpers/urls";
import { generateLineChartData } from "variables/charts_new";
import { generateLineChartOptions } from "variables/charts_new";


const TotalSpent = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [chartOptions, setChartOptions] = useState({});
  const [chartSeries, setChartSeries] = useState([]);
  const [modalChartOptions, setModalChartOptions] = useState({});
  const [modalChartSeries, setModalChartSeries] = useState([]);
  const [chartKey, setChartKey] = useState(0);

  const { data, loading, error } = useFetch({
    url: urls.logsCount,
  });

  useEffect(() => {
    if (data && data.data) {
      const dates = data.data.map((item) => item.date);
      const counts = data.data.map((item) => item.count);
      setChartOptions(generateLineChartOptions(dates));
      setChartSeries(generateLineChartData(counts));
    }
  }, [data]);

  const showModal = () => {
    if (data && data.data) {
      const now = new Date();
      const year = now.getFullYear();
      const month = now.getMonth();
      const daysInMonth = new Date(year, month + 1, 0).getDate();

      const countsMap = new Map();
      data.data.forEach(item => {
        const itemDate = new Date(item.date);
        countsMap.set(itemDate.getDate(), item.count);
      });

      const allMonthDates = [];
      const allMonthCounts = [];

      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(year, month, day);
        allMonthDates.push(date.toISOString());
        allMonthCounts.push(countsMap.get(day) || 0);
      }

      setModalChartOptions(generateLineChartOptions(allMonthDates));
      setModalChartSeries(generateLineChartData(allMonthCounts));
    }
    setIsModalVisible(true);
  };

  const handleAfterOpenChange = (open) => {
    if (open) {
      // Force re-render after modal is fully open
      setChartKey(prevKey => prevKey + 1);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <Card extra="!p-[20px] text-center" style={{border:"1px solid #81aae780"}}>
      <div className="flex justify-between">
         <h2 className="text-[24px] font-[600] text-[#000] dark:text-white" style={{ fontFamily: "figtree" }}>
          Monthly Utilization
        </h2>
        {/* <button className="linear mt-1 flex items-center justify-center gap-2 rounded-lg bg-lightPrimary p-2 text-gray-600 transition duration-200 hover:cursor-pointer hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:hover:opacity-90 dark:active:opacity-80">
          <MdOutlineCalendarToday />
          <span className="text-sm font-medium text-gray-600">This month</span>
        </button> */}
        <button onClick={showModal} className="!linear flex items-center justify-center rounded-lg bg-lightPrimary p-2 text-[#2369d2] !transition !duration-200 hover:bg-gray-100 active:bg-gray-200 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10">
          <Tooltip title="Maximize the screen">
            <TbArrowsMaximize className="h-5 w-5" />
          </Tooltip>
        </button>
      </div>

      <div className="flex h-full w-full flex-row justify-between sm:flex-wrap lg:flex-nowrap 2xl:overflow-hidden">
        <div className="flex flex-col">
          <p className="mt-[20px] text-3xl font-bold text-navy-700 dark:text-white">
          </p>
        </div>
        <div className="h-full w-full">
          {!loading && (
            <LineChart
              options={chartOptions}
              series={chartSeries}
            />
          )}
        </div>
      </div>
      <Modal title="Total Spent Analysis" open={isModalVisible} onCancel={handleCancel} footer={null} width="80vw" afterOpenChange={handleAfterOpenChange}>
        <div style={{ height: '70vh' }}>
          {!loading && (
            <LineChart
              key={chartKey}
              options={modalChartOptions}
              series={modalChartSeries}
            />
          )}
        </div>
      </Modal>
    </Card>
  );
};

export default TotalSpent;
